import { FC, PropsWithChildren } from "react";
import { Button, ButtonVariant, ButtonSize } from "shared/components";

interface Props {
  title: string;
  onRemove?: () => void;
}

export const QuestionCard: FC<PropsWithChildren<Props>> = ({
  title,
  onRemove,
  children
}) => {
  return (
    <div className="p-5 border border-alpha-80 rounded-lg bg-alpha-20">
      <div className="flex items-center justify-between pb-4 border-b border-alpha-40">
        <p className="text-content-500 text-sm">{title}</p>
        {onRemove ? (
          <Button
            size={ButtonSize.SM}
            variant={ButtonVariant.TEXT}
            className="cursor-pointer text-base font-bold text-primary-500"
            onClick={onRemove}
          >
            Remove
          </Button>
        ) : null}
      </div>
      <div className="pt-4">{children}</div>
    </div>
  );
};
